interface ProfileProps {
  isGrey?: boolean;
}

const Profile: React.FC<ProfileProps> = () => {
  return (
    <svg
      width="41"
      height="41"
      viewBox="0 0 41 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20.5" cy="20.75" r="20" fill="#F5F5F5" />
      <path
        d="M11.5 28.75C13.8358 26.2726 17.007 24.75 20.5 24.75C23.993 24.75 27.1642 26.2726 29.5 28.75M25 16.25C25 18.7353 22.9853 20.75 20.5 20.75C18.0147 20.75 16 18.7353 16 16.25C16 13.7647 18.0147 11.75 20.5 11.75C22.9853 11.75 25 13.7647 25 16.25Z"
        stroke="black"
        strokeOpacity="0.5"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Profile;
